/** Mensajes y reset de campos en login fallido (sin recargar). */

export function loginErrorMessage(err: unknown): string {
  const fallback = "Usuario o contraseña incorrectos.";
  if (!err || typeof err !== "object") return fallback;
  const e = err as {
    message?: unknown;
    details?: unknown;
    status?: unknown;
    error?: unknown;
  };
  const pieces: string[] = [];
  if (typeof e.message === "string") pieces.push(e.message);
  if (typeof e.details === "string") pieces.push(e.details);
  if (e.details && typeof e.details === "object") {
    const d = e.details as Record<string, unknown>;
    if (typeof d.detail === "string") pieces.push(d.detail);
    if (typeof d.message === "string") pieces.push(d.message);
  }
  const blob = pieces.join(" ").toLowerCase();
  if (blob.includes("inactiv")) {
    return "Este usuario está inactivo y no puede iniciar sesión.";
  }
  if (
    blob.includes("unable to connect") ||
    blob.includes("network error") ||
    blob.includes("failed to fetch")
  ) {
    return "No se pudo conectar con el servidor.";
  }
  const spanish = pieces.find(
    (p) =>
      /usuario|contraseña|inactivo|sesión|código|mfa|intento/i.test(p) &&
      !/unauthorized|no active account/i.test(p),
  );
  if (spanish) return spanish;
  if (e.status === 401 || e.status === 400) return fallback;
  return fallback;
}

export function loginRetryAfterSeconds(err: unknown): number {
  if (!err || typeof err !== "object") return 0;
  const e = err as { details?: unknown; data?: unknown; retryAfter?: unknown; retry_after?: unknown };
  const bags = [e, e.details, e.data];
  for (const bag of bags) {
    if (!bag || typeof bag !== "object") continue;
    const row = bag as Record<string, unknown>;
    const raw = row.retryAfter ?? row.retry_after;
    const n = typeof raw === "number" ? raw : Number(raw);
    if (Number.isFinite(n) && n > 0) return Math.ceil(n);
  }
  return 0;
}

export function loginWaitText(seconds: number): string {
  if (seconds > 0) {
    return `Demasiados intentos. Esperá un momento e intentá de nuevo. ${seconds}s`;
  }
  return "Ya podés intentar de nuevo.";
}

/** Fallo de login (API): vaciar usuario y clave; el alert inline usa `error`. */
export function applyFailedLogin(err: unknown): {
  username: "";
  password: "";
  error: string;
} {
  return { username: "", password: "", error: loginErrorMessage(err) };
}

/** Fallo del segundo paso / wizard: vaciar el código; no recargar la página. */
export function applyFailedMfa(err: unknown): { code: ""; error: string } {
  return { code: "", error: loginErrorMessage(err) };
}
